import lozad from 'lozad'
import Splitting from 'splitting'

const taskList = []

function processTaskList(taskStartTime) {
  let taskFinishTime

  do {
    const nextTask = taskList.pop()
    if (typeof nextTask === 'function') {
      nextTask()
    }
    taskFinishTime = window.performance.now()
  } while (taskFinishTime - taskStartTime < 3)

  if (taskList.length > 0) requestAnimationFrame(processTaskList)
}

if (!document.documentElement.classList.contains('touchevents')) {
  Splitting()
  Splitting({
    target: '.splitting-grid',
    by: 'items',
    matching: '.splitting-grid-item'
  })
  Splitting({
    target: '.swiper-container.with-animation',
    by: 'items',
    matching: '.swiper-slide'
  })
  setTimeout(() => {
    lozad('[data-splitting], .fade-in, .splitting-grid, .swiper-container', {
      // rootMargin: '-600px 0px 0px 0px',
      threshold: 0.25,
      load(el) {
        taskList.push(() => {
          el.classList.add('animated')
        })
        if (el.classList.contains('splitting-grid')) {
          el.querySelectorAll('.splitting-grid-item').forEach((item) => {
            item.addEventListener('transitionend', () => {
              taskList.push(() => {
                item.classList.remove('splitting-grid-item')
              })
            })
          })
        }
        if (el.classList.contains('fade-in')) {
          el.addEventListener('transitionend', () => {
            taskList.push(() => {
              el.classList.remove('fade-in')
            })
          })
        }

        requestAnimationFrame(processTaskList)
      }
    }).observe()
  }, 300)
}
